import { useNavigate } from 'react-router-dom';

/**
 * "← Back" control for detail / drill-in pages. Returns to the screen the user
 * came from (browser history). If the page was deep-linked (no in-app history),
 * falls back to `fallback` (default /) so Back is never a dead end.
 */
export default function BackButton({ label = 'Back', fallback = '/', className = '' }) {
  const navigate = useNavigate();
  const onClick = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-sm text-crimson hover:underline flex items-center gap-1 ${className}`}
    >
      ← {label}
    </button>
  );
}
